import { Switch } from "@/shared/ui/switch"
import { Label } from "@/shared/ui/label"
import { cn } from "@/shared/lib/utils"

interface CustomSwitchProps {
    id: string
    label: string
    descriptionOn: string
    descriptionOff: string
    iconOn: React.ReactNode
    iconOff: React.ReactNode
    checked: boolean
    onChange: (checked: boolean) => void
    className?: string
    disabled?: boolean
}

export function CustomSwitch({
    id,
    label,
    descriptionOn,
    descriptionOff,
    iconOn,
    iconOff,
    checked,
    onChange,
    className,
    disabled = false
}: CustomSwitchProps) {
    return (
        <div className={cn("flex items-center justify-between p-4 border border-white/10 bg-neutral-800/30 rounded-lg", className)}>
            <div className="flex items-center gap-3">
                {checked ? iconOn : iconOff}
                <div>
                    <Label htmlFor={id} className="text-neutral-200 font-medium">
                        {label}
                    </Label>
                    <p className="text-xs text-neutral-400">
                        {checked ? descriptionOn : descriptionOff}
                    </p>
                </div>
            </div>
            <Switch checked={checked} onCheckedChange={onChange} id={id} disabled={disabled} />
        </div>
    )
}
